// extracted by mini-css-extract-plugin
export var discard = "_40-3";
export var muiTooltipTooltip = "_40-5";
export var notificationBar = "_40-2";
export var saveButtonHoverSlotWrapper = "_40-4";
export var show = "_40-1";
export var spacer = "_40-0";